import { gateway } from "../../../../gateway";

export const getSuppliesProvidersId = async ({ token, id, page, pageSize }) => {
  try {
    const res = await gateway.get(`/supplies/providers/self/${id}/?page=${page}&pageSize=${pageSize}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
